import {useEffect, useState} from "react";
import {apiService} from "../services/axios";
import {useAuth} from "../provider/AuthProvider";

function SharePage() {
    const [shareLink, setShareLink] = useState("");
    const [copySuccess, setCopySuccess] = useState(false);
    const { token, isReady } = useAuth();

    useEffect(() => {
        apiService.get('/api/me/share-link', isReady, token)
            .then((response) => {
                setShareLink(response.data.shareLink)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [isReady, token]);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(shareLink);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (err) {
            console.error('Erreur lors de la copie:', err);

            const textArea = document.createElement('textarea');
            textArea.value = shareLink;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };

    const openInNewTab = () => {
        if (shareLink) {
            window.open(shareLink, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className="hero-body">
            <div className="container">
                <h1 className="title is-2">Partager ma collection</h1>
                <div className="box">
                    <div className="field">
                        <label className="label">Lien de partage</label>
                        <div className="field">
                            <div className="control">
                                <input
                                    className="input"
                                    type="text"
                                    value={shareLink}
                                    readOnly
                                    placeholder="Chargement du lien..."
                                />
                            </div>
                        </div>
                        <div className="field is-grouped is-grouped-multiline">
                            <div className="control">
                                <button
                                    className={`button  has-text-light ${copySuccess ? 'is-success' : 'is-info'}`}
                                    onClick={copyToClipboard}
                                    disabled={!shareLink}
                                >
                                    <span className="icon">
                                        <i className={`fas ${copySuccess ? 'fa-check' : 'fa-copy'}`}></i>
                                    </span>
                                    <span>{copySuccess ? 'Copié !' : 'Copier'}</span>
                                </button>
                            </div>
                            <div className="control">
                                <button
                                    className="button is-primary has-text-light"
                                    onClick={openInNewTab}
                                    disabled={!shareLink}
                                >
                                    <span className="icon">
                                        <i className="fas fa-external-link-alt"></i>
                                    </span>
                                    <span>Ouvrir</span>
                                </button>
                            </div>
                        </div>
                    </div>
                    {shareLink && (
                        <div className="notification is-info is-light">
                            <p className="is-size-10">
                                <span className="icon"><i className="fas fa-info-circle"></i></span>
                                Ce lien permet à d'autres personnes de consulter votre collection de BD.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SharePage;
